<app-view #view [code]="'zones.edit'" [model]="zone" (onEvent)="onEvent($event)"></app-view>